
import { Box, Divider, Text, useColorModeValue } from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchAsyncGetOrganizationUsers } from "redux/organizationSlice";
import OrgUserTable from "./components/orgUserTable";
import "./dashboard.css"

export default function UserReports() {
 
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [orgUsersList,setOrgUserList] = useState([])

  const [allOrgUsers,setAllOrgUsers] = useState([])

  useEffect(() => {
    const fetchAllOrgUsers = async () => {
      setLoading(true);
      try {
        const users = await dispatch(fetchAsyncGetOrganizationUsers()).unwrap();
        setOrgUserList(users)
      } catch (error) {
        console.error("Failed to fetch organizations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllOrgUsers();
  }, [dispatch]);

  useEffect(() => {
    if (orgUsersList && orgUsersList.length > 0) {
      const tableData = orgUsersList.map((data, index) => {
        return {
          _id:data?._id,
          no: index + 1,
          name: data.name,
          orgName: data?.orgId?.name,
          email: data.mail,
          createdAt:data.crAt
        };
      });
      setAllOrgUsers(tableData);
    } else {
      setAllOrgUsers([]);
    }
  }, [orgUsersList]);

  return (
    <Box display="flex" className="mx-0" justifyContent="space-between" flexDirection="column">
      <Box display="flex" className="mx-3">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
        >
          Dashboard
        </Text>
        </Box>
        <Box className="main-dashboard" pt={{ base: "30px", md: "30px", xl: "30px" }}>

          <Box className="user-table-container">
            <p className="table-heading">Registred Users</p>
            <p className="table-pre">{allOrgUsers?.length} registered users</p>
            <Divider className="mt-3"/>
            <OrgUserTable users={allOrgUsers}/>
          </Box>
        </Box>
  
    </Box>
  );
}
